import React, { useState } from "react";
import { LuRepeat, LuX } from "react-icons/lu";

import { SetupCard } from "../../../../../components/newUI/setup-card";
import {
  describeScheduleForm,
  RecurringScheduleForm,
  ScheduleWork,
} from "../../../../work/pages/repeats/recurringSchedule";
import { RecurringScheduleModal } from "../../../../work/pages/repeats/RecurringScheduleModal";

type Props = {
  draft: RecurringScheduleForm | null;
  onChange: (draft: RecurringScheduleForm | null) => void;
  /** The dates typed in the New work window (may still be empty). */
  work: Partial<ScheduleWork>;
};

/** New work window: a repeat schedule that starts once the work is created. */
export const AddWorkRepeatSection: React.FC<Props> = ({
  draft,
  onChange,
  work,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const today = new Date();
  const scheduleWork: ScheduleWork = {
    startDate: work.startDate || today,
    dueDate: work.dueDate || work.startDate || today,
  };

  return (
    <div className={"mt-1 border-t border-[#ECEFF3] pt-[18px]"}>
      {draft ? (
        <div
          role={"button"}
          tabIndex={0}
          onClick={() => setIsOpen(true)}
          onKeyDown={(event) => {
            if (event.key === "Enter") setIsOpen(true);
          }}
          className={
            "flex cursor-pointer gap-3 rounded-[11px] border border-l-[3px] border-[#E4E7EC] border-l-[#6B4EFF] bg-white px-4 py-3 text-left"
          }>
          <span
            className={
              "flex h-9 w-9 shrink-0 items-center justify-center rounded-[9px] bg-[#F0EDFF] text-[#6B4EFF]"
            }>
            <LuRepeat className={"h-[18px] w-[18px]"} />
          </span>
          <div className={"min-w-0 flex-1"}>
            <div className={"text-[14px] font-bold text-[#1F2433]"}>
              Repeat schedule
            </div>
            <div
              className={"mt-0.5 text-[12.5px] leading-[1.45] text-[#5B6678]"}>
              {describeScheduleForm(draft)}
            </div>
            <div className={"mt-1 text-[12px] text-[#8A90A2]"}>
              Will start when this work is created
            </div>
          </div>
          <button
            type={"button"}
            aria-label={"Remove repeat schedule"}
            onClick={(event) => {
              event.stopPropagation();
              onChange(null);
            }}
            className={"self-start text-[#A3A9B8] hover:text-[#E5484D]"}>
            <LuX size={16} />
          </button>
        </div>
      ) : (
        <SetupCard
          icon={<LuRepeat className={"h-[18px] w-[18px]"} />}
          title={"Add a repeat schedule"}
          description={"Automatically recreate this work on a recurring basis."}
          onClick={() => setIsOpen(true)}
        />
      )}

      {isOpen && (
        <RecurringScheduleModal
          work={scheduleWork}
          initialForm={draft || undefined}
          isDraft
          onClose={() => setIsOpen(false)}
          onSave={(_payload, form) => {
            onChange(form);
            setIsOpen(false);
          }}
        />
      )}
    </div>
  );
};
